// extracted by mini-css-extract-plugin
export default {"container":"Term_container__dNr0C"};